'use client';

import dynamic from 'next/dynamic';
import { ReactNode } from 'react';

import { env } from '@natu/env';
import { Link } from '@natu/next-link';
import { usePageContext } from '@natu/utils/PageContextProvider';

import { getLinkPropsFromStoryblok, StoryblokLink } from '../../../../utils';

const Button = dynamic(() => import('@natu/ui/Button').then(mod => mod.Button));

const ButtonWithEvent = dynamic(() =>
  import('@natu/ui/Button/ButtonWithEvent').then(mod => mod.ButtonWithEvent),
);

export type MarkLinkProps = {
  linktype?: string;
  href?: string;
  target?: string;
  anchor?: string;
  uuid?: string;
  children: ReactNode;
};

export const MarkLinkComponent = ({
  children,
  href,
  uuid,
  linktype,
  target,
  anchor,
}: MarkLinkProps) => {
  const { isArticle } = usePageContext() || {};

  const hrefWithoutAppFolder = href?.replace(`${env.NEXT_PUBLIC_STORYBLOK_MAIN_APP_FOLDER}/`, '');

  const storyblokLink = {
    id: uuid,
    linktype,
    cached_url: hrefWithoutAppFolder,
    email: hrefWithoutAppFolder,
    url: hrefWithoutAppFolder,
    target,
    anchor,
  } as StoryblokLink;

  const linkProps = getLinkPropsFromStoryblok(storyblokLink);

  if (isArticle) {
    return (
      <ButtonWithEvent
        event="E_click_blog_internal_link_text"
        variant="link"
        className="inline p-0"
        asChild
      >
        <Link className="no-underline" {...linkProps}>
          {children}
        </Link>
      </ButtonWithEvent>
    );
  }

  return (
    <Button variant="link" className="inline p-0" asChild>
      <Link className="no-underline" {...linkProps}>
        {children}
      </Link>
    </Button>
  );
};
